import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getMoreNews} from '../../../../redux/actions/news';
import {contentSelector} from '../../../../redux/selectors/resources';
import {Button} from '../../../../shared/components/button';
import {Container} from '../../../../shared/components/container';
import {NewsCard} from '../../../../shared/components/newsCard';
import {Text} from '../../../../shared/components/text';
import {useStyles} from '../../../../shared/hooks/styles';
import {blur} from '../../../../shared/utils/blur';
import {ViewProps} from './model';

const cardMargin = 20;

export default ({news, newsNotFound}: ViewProps) => {
  const dispatch = useDispatch();
  const content = useSelector(contentSelector());

  const styles = useStyles(() => ({
    btnMore: {
      marginTop: 30,
      width: '100%',
      marginLeft: 0,
    },
    newsCard: {
      marginTop: cardMargin,
    },
    noMoreNewsText: {
      marginTop: 30,
      textAlign: 'center',
    },
  }));

  const onMoreBtnPress = React.useCallback(() => {
    blur();
    dispatch(getMoreNews());
  }, []);

  return (
    <Container>
      {newsNotFound && <Text style={styles.noMoreNewsText}>{content.news.noNewsInSelectedPeriod}</Text>}
      {news.selection.map((newsItem) => (
        <NewsCard news={newsItem} style={styles.newsCard} key={newsItem.id} />
      ))}
      {news.moreNewsAvailable && (
        <Button id='news-more' type='secondary' text='Показать еще' style={styles.btnMore} onPress={onMoreBtnPress} />
      )}
    </Container>
  );
};
